// Gatsby requirements
import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import SeoStructuredData from './seoStructuredData'
import Button from 'utils/linkLogic'

// Styles
import * as CSS from './sectionNumberedVerticalCards.module.scss'

const SectionNumberedVerticalCards = ({ blok, currentPage }) => {

    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null,
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                {blok?.title &&
                    <h2>{blok.title}</h2>
                }

                {blok?.description &&
                    <p>{blok.description}</p>
                }

                <ol className={CSS.cards}>
                    {blok?.cards &&
                        <>
                        {blok?.cards?.map((loop, index) => (

                            <li
                                className={CSS.card}
                                style={{
                                    backgroundColor: blok.backgroundColor === '#f1f1ef' ? '#fff' : '#f1f1ef',
                                    marginBottom: blok?.removeBottomMargin ? '0' : null,
                                }}
                                id={`howto-${blok._uid}-step-${index + 1}`}
                            >

                                <span className={CSS.text}>
                                    <span className={CSS.titleAndNumber}>
                                        <span aria-hidden="true" className={`${CSS.number} ${blok.backgroundColor !== '#f1f1ef' ? CSS.blue : ''}`}>{index + 1}</span>
                                        {loop?.title &&
                                            <h3>{loop.title}</h3>
                                        }
                                    </span>
                                    {loop?.description &&
                                        <p>{loop.description}</p>
                                    }
                                    {loop?.button?.map(loop2 => (
                                        <Button data={loop2} />
                                    ))}
                                </span>

                                {loop?.image?.filename &&
                                    <span className={CSS.image}>
                                        <img
                                            src={loop.image.filename}
                                            loading="lazy"
                                            width={loop?.image?.filename?.split('/')[5]?.split('x')[0]}
                                            height={loop?.image?.filename?.split('/')[5]?.split('x')[1]}
                                            alt={loop.image.alt}
                                        />
                                    </span>
                                }

                            </li>

                        ))}
                        </>
                    }
                </ol>

            </div>

            <SeoStructuredData data={
                `{
                    "@context": "https://schema.org",
                    "@type": "HowTo",
                    "name": "${blok.title}",
                    "step": [
                        ${blok.cards.map((loop, index) => {
                            return (
                            `{
                                "@type": "HowToStep",
                                "url": "https://www.wa.nl${currentPage}#${`howto-${blok._uid}-step-${index + 1}`}",
                                "name": "${loop.title}",
                                "itemListElement": [{
                                  "@type": "HowToDirection",
                                  "text": "${loop.description}"
                                }]
                                ${loop?.image?.filename !== null && loop?.image?.filename !== "" ? `
                                ,
                                "image": {
                                  "@type": "ImageObject",
                                  "url": "${loop.image.filename}",
                                  "height": "${loop?.image?.filename?.split('/')[5]?.split('x')[1]}",
                                  "width": "${loop?.image?.filename?.split('/')[5]?.split('x')[0]}"
                                }
                                ` : '' }
                            }`
                            )
                        })}
                    ]
                  }`
            } />

        </section>
    )
}

export default SectionNumberedVerticalCards